import { Component } from '@angular/core';
import {DialogService, DynamicDialogRef} from 'primeng/dynamicdialog';
import {TranslateService} from '@ngx-translate/core';
import {DialogHelper} from '../../../../../shared/helper/dialog-helper';
import {PlayerProfileFeaturesComponent} from '../player-profile-features/player-profile-features.component';

@Component({
  selector: 'app-player-profile-features-dialog',
  imports: [
    PlayerProfileFeaturesComponent
  ],
  templateUrl: './player-profile-features-dialog.component.html',
  styleUrl: './player-profile-features-dialog.component.scss'
})
export class PlayerProfileFeaturesDialogComponent
{

  public static showDialog(dialogService: DialogService, translate: TranslateService): DynamicDialogRef
  {
    return dialogService.open(
      PlayerProfileFeaturesDialogComponent,
      DialogHelper.createBasicConfig({
        header: translate.instant('PLAYER_PROFILE_FEATURES'),
        width: DialogHelper.getDialogWidth(700),
      }));
  }
}
